<template>
	<div class="qksm qksm3">
		<div class="nogap">
			<h4>三、支出决算情况说明</h4>
			<p>
				2021年度本年支出决算合计{{isMoney(T3.总计)}}万元，其中：
				<template v-for="(item, idx) in T3.项目">
					{{item.name}}{{isMoney(item.value)}}万元，占{{getPercentValue(T3.项目.map(e=>e.value), idx, 2)}}{{idx==T3.项目.length-1?'。':'；'}}
				</template>
			</p>
		</div>
		<div id="myChart3" class="echart" v-if="(!isPdf && $parent.isData) || isPdf"></div>
	</div>
</template>
<script>
	export default {
		name: "qksm3",
		data() {
			return {
				isPdf: this.$parent.isPdf,
			}
		},
		props: {
			T3: {
				type: Object,
				default: "",
			},
		},
	};
</script>